import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { SwiftTransfers, ScanBeneficiary, updateSwiftTransfers } from 'src/app/interfaces/apiresponses';
import { DatePipe } from '@angular/common';
import { FUND_TRANSFER_STATUS } from 'src/app/shared/constants/fund-transfer-statuses';
import { debounce, truncate } from 'lodash';

@Component({
  selector: 'app-swift-transfer',
  templateUrl: './swift-transfer.component.html',
  styleUrls: ['./swift-transfer.component.scss'],
  providers: [DatePipe]
})
export class SwiftTransferComponent {
  bUndefined!: boolean
  selectedItem: any
  getSwiftData: any = []
  myForm!: FormGroup
  decisionSaveModel: boolean = false

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  Toggle: boolean = false
  serviceTypes: any
  date = new Date();
  bReject: boolean = false;
  today = (new Date()).getDay();

  // startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 11);
  // endDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.today);

  startDate:Date =new Date(this.date.getFullYear(), this.date.getMonth(), this.today -3);

  endDate: Date = new Date();

  public disabledDates = [[new Date(new Date())]]

  /*Reject reason */

  bRejectReason = false;
  bValidRejectReason!: boolean
  txtrejectionReason: string = ''
  rejectReasonForm: FormGroup;

  constructor(private restApi: RestService, 
    private datePipe: DatePipe, 
    private changeDetector: ChangeDetectorRef) {

      this.rejectReasonForm = new FormGroup({
        rejectReasonControl: new FormControl(this.txtrejectionReason, [Validators.required, Validators.minLength(3)])
      });
  }

  columns = [

    {
      key: 'cif',
      label: 'CIF',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'transactionId',
      label: 'Transaction #',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'benCountry',
      label: 'Beneficiary Country',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'benCurrency',
      label: 'Beneficiary Currency',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'senderAccountNumber',
      label: 'Debit Account',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'debitAmount',
      label: 'Debit Amount',
      filter: true
    },
    {
      key: 'transferType',
      label: 'Transfer Type',
      filter: true
    },
    // {
    //   key: 'isDecisionTaken',
    //   label: 'Status',
    //   filter: true
    // },
    {
      key: 'rejectReason',
      label: 'Reject Reason',
      filter: true
    },

    {
      key: 'status',
      label: 'Status',
      filter: true
    },
    
  ];
  // Reject Form
  bShowReason = false
  bValidReason!: boolean
  rejectionReason: string = ''
  rejectionForm = new FormGroup({
    reasonControl: new FormControl(this.rejectionReason, [Validators.required, Validators.minLength(1)])
  })
  get reasonControl() { return this.rejectionForm.get('reasonControl')  }

  ifReasonValid() {
    let returnVal = ''
    if (this.reasonControl?.invalid && (this.reasonControl?.dirty || this.reasonControl?.touched)) {
      this.bValidReason = false
      if (this.reasonControl?.errors?.['required'])
        returnVal =  'Transaction ID is required'
      else if (this.reasonControl?.errors?.['minlength'])
        returnVal = 'Name must be at least 1 characters long'
      else
        returnVal = 'Enter a valid TansactionID'
     
    } else {
      let regIdType = new RegExp('^(?=.*[a-zA-z])(?=.*[0-9])[A-Za-z0-9]+$')
      if(this.reasonControl?.value){
        if(!regIdType.test(this.reasonControl?.value) && this.reasonControl?.touched){
         
          returnVal = 'Please enter only Alphanuric Value!(Ex:3584a4f7j3)'
          this.bValidReason = false
        }else{
         
          //this.customerIDNumberValid = true
          returnVal = ''
        
          if (this.reasonControl?.dirty || this.reasonControl?.touched)
          {
            this.bValidReason = true
          }
        }
      }
      
     
    }
    return returnVal
  }
  ngOnInit() {
    console.log(this.reasonControl)
    console.log(this.rejectReasonControl)
    // this.getServices()
  }
  serviceData: IItem[] = []
  selectedItems = [2, 3];

  // Resolution Form
  bShowResolution = false
  bValidResolution!: boolean
  resolutionText: string = ''

  rowDataDetail: any;
  rowSelected(event: any) {
    this.decisionSaveModel = true
    console.log(event.item)
    if (this.decisionSaveModel) {
      this.rowDataDetail = event.item 
    }

  }
  amlstatus: boolean = false;
  amlstatusVal: any
  updateBeneficiaryId() {
   
    let payload = {
      "benefiaryId": this.rowDataDetail?.beneficiaryId.toString()
    }
    this.restApi.scanBeneficiary(payload).subscribe({
      next: (v: ScanBeneficiary) => {
        // console.log(v)
        if (v.success) {
          if (v.amlstatus === "Approved" || v.amlstatus === "AutoApproved") {
            this.amlstatus = true
            this.amlstatusVal = "Approved"
            this.rowDataDetail.latestAmlstatus = "Approved"
            this.showAlertBox('Approved', 'transaction is in Approved state!')
          } else if (v.amlstatus === "Pending") {
            this.amlstatus = false
            this.showAlertBox('Pending', 'Please contact the compliance team with the case ID ' + v.amlcaseId + ' as the transaction is in Pending state.')
          } else if (v.amlstatus === "Rejected") {
            this.amlstatus = false
            this.showAlertBox('Rejected', 'transaction is in Rejected state!')
          }
        }

      },
      error: (e) => {

      }
    })
  }
  
  showReasonModal() {
    this.reasonControl?.setValue(this.rowDataDetail?.transactionId ?? '');
    this.rejectionReason = ''
    this.bValidReason = this.bUndefined
    this.bShowReason = true
  }

  deactivateBen() {
    this.showAlertBox('Confirmation', 'Are you sure you to reject this payment ?', 'No', true, 'Yes', { action: 1 })
  }
  
  confirm() {
    let regIdType = new RegExp('^(?=.*[a-zA-z])(?=.*[0-9])[A-Za-z0-9]+$')
   if(this.reasonControl?.value != undefined)
   if(!regIdType.test(this.reasonControl?.value) && this.reasonControl?.touched){
    this.bShowReason = false
     this.showAlertBox('Sorry', 'Transaction ID should be Alphanuric Value!(Ex:3584a4f7j3)')
     return
   }
    let payload = {
      "uniqueId": this.rowDataDetail?.uniqueId,
      "transactionId": this.rejectionForm?.value?.reasonControl,
      "isApproved": true
    }
    
    this.restApi.updateSwiftTransfer(payload).subscribe({
      next: (v: updateSwiftTransfers) => {
      
      if(v.success){
        this.bShowReason = false
        this.showAlertBox('Approved', 'Payment has been sucessufully approved.')
        this.goBackToSearchScreen()
      }else{
        this.goBackToSearchScreen()
        this.bShowReason = false
        this.showAlertBox('Alert', v.message)
      }

      },
      error: (e) => {

      }
    })




  }
  deactivate() {   
    let payload = {
      "uniqueId": this.rowDataDetail?.uniqueId,
      //"transactionId": "",
      "isApproved": false
    }
    this.restApi.updateSwiftTransfer(payload).subscribe({
      next: (v: updateSwiftTransfers) => {
      if(v.success){
        this.goBackToSearchScreen()
        this.showAlertBox('Rejected', 'Payment has been rejected.')
      }else{
        this.goBackToSearchScreen()
        this.showAlertBox('Alert', v.message)
      }

      },
      error: (e) => {

      }
    })
  }

  goBackToSearchScreen() {
    this.decisionSaveModel = false;
    this.getServices()

  }
  closeResolutionModal() {
    this.bShowResolution = false
  }

  onStartDateChane(event: any) {
    this.startDate = event
    this.serviceData = []
  }

  onEndDateChane(event: any) {
    this.endDate = event
    this.serviceData = []
  }

  onSelectChange() {
    this.serviceData = []
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getDateString(dateValue: Date) {
    return this.datePipe.transform(dateValue, "yyyy-MM-dd")
  }

  getDisplayDate(item: any) {
    return this.datePipe.transform(item.dateCreated, "dd-MM-yyyy")
  }
  // Search Form
  searchServiceType: string = ''
  toogle: any = '';

  cifSearchForm = new FormGroup({

    toogle: new FormControl(this.toogle),
  })

  getServices() {
    let startDateString = this.getDateString(this.startDate)
    let endDateString = this.getDateString(this.endDate)
    let payload = {
      "startDate": startDateString,
      "endDate": endDateString,
      "filter": this.cifSearchForm.value?.toogle
    }
    
    // if (this.cifSearchForm.value?.toogle != null || this.cifSearchForm.value?.toogle != "" ) {
    //   this.showAlertBox('Sorry', 'Please select Status.')
    //   return
    // }
    if (  startDateString != null && endDateString != null) {
      this.restApi.getSwiftTransfers(payload).subscribe({
        next: (v: SwiftTransfers) => {          
          this.serviceData = v.swiftTransfers.map((item, Reference) => {
            // let status = '';
            // if (item?.isDecisionTaken && item?.isApproved) {
            //   status = 'Approved'
            // } else {
            //   if (!item?.isDecisionTaken) {
            //     status = 'Pending'

            //   } else if (item?.isDecisionTaken && !item?.isApproved) {
            //     status = 'Rejected'
            //   } else {
            //     status = 'Unknown'
            //   }
            // } 
            
            const _selected = this.selectedItems.includes(Reference);
            return {
              ...item,
              _selected,
              //isDecisionTaken: status,
              img: 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='
            };
          })
        },
        error: (e) => {

        }
      })
    }
  }

  tooglebutton: boolean = false



  closeAlert(event: any) {

  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {
    this.bAlert = event.state
    console.log(event.data.action)
    if (event.data.action === 1) {
      this.showRejectReasonModal();
      //this.deactivate()
    }
    if (event.data.action === 2) {
      this.goBackToSearchScreen()
    }
  }
  closeReasonModal() {
    this.bShowReason = false
    // this.goBackToSearchScreen();
  }

  getStatusBadge(item: any) {
    if (item?.status === FUND_TRANSFER_STATUS.APPROVED
      || item?.status === FUND_TRANSFER_STATUS.SUCCESS) {
      return 'success'
    }
    if (item?.status === FUND_TRANSFER_STATUS.REJECTED
      || item?.status === FUND_TRANSFER_STATUS.FAILED) {
      return 'danger'
    }

    if (item?.status === FUND_TRANSFER_STATUS.PENDING) {
      return 'warning'
    }
    return 'secondary';
  }

  activeCardColor = { color: 'success', textColor: 'primary' }
  inactiveCardColor = { color: 'danger', textColor: 'secondary' }
  getStatus(item: any) {
    if(item?.isDecisionTaken && item?.isApproved){
      return 'Approved'
    }else{
      if(!item?.isDecisionTaken){
        return 'Pending'
  
      }else if(item?.isDecisionTaken && !item?.isApproved)    {
        return 'Rejected'
      }else  {
        return 'Unknown'
    }
    } 
    
  }

  checkActionVisibility() {
  
    console.log('checkActionVisibility() called')
 
    if (this.rowDataDetail.status === FUND_TRANSFER_STATUS.SUCCESS
      || this.rowDataDetail.status === FUND_TRANSFER_STATUS.APPROVED
      || this.rowDataDetail.status === FUND_TRANSFER_STATUS.REJECTED
      || this.rowDataDetail.status === FUND_TRANSFER_STATUS.FAILED)

      return false;

    if (this.rowDataDetail.status === FUND_TRANSFER_STATUS.PENDING)
      return true;

    return false;
  }
  checkApproveVisibility() {
  
    var istrue = false;
 
    if (this.rowDataDetail?.latestAmlstatus === FUND_TRANSFER_STATUS.PENDING)
      return false;
    else
      return true;

  }

  //Capture Reject Reason
  get rejectReasonControl() { return this.rejectReasonForm.get('rejectReasonControl')  }

  isRejectReasonValid(): string {
    const control = this.rejectReasonForm.get('rejectReasonControl');

    if (control?.hasError('required')) {
      return 'Reason is required.';
    }
    if (control?.hasError('minlength')) {
      return 'Reason must be at least 3 characters long.';
    }

    // Check for alphanumeric error
    const regIdType = new RegExp('^[a-zA-Z0-9\\s]*$');
    if (control?.value && !regIdType.test(control.value)) {
      // Add alphanumeric error
      control.setErrors({ ...control.errors, alphanumeric: true });
      return 'Reason must contain only Alphanuric Value!(Ex:3584a4f7j3).';
    }
  
    // Clear alphanumeric error if input is valid
    if (control?.errors?.['alphanumeric']) {
      const { alphanumeric, ...remainingErrors } = control.errors;
      control.setErrors(remainingErrors);
    }

    return '';
  }
  
  showRejectReasonModal() {
    this.rejectReasonForm.reset();
    this.bRejectReason = true;
  }

  closeRejectReasonModal() {
    this.bRejectReason = false;
    this.rejectReasonForm.reset();
  }

  btnRejectConfirm() {

    if (this.rejectReasonForm.valid) {
      let payload = {
        "uniqueId": this.rowDataDetail?.uniqueId,
        "RejectReason": this.rejectReasonForm?.value?.rejectReasonControl,
        "Status":"Rejected",
        "isApproved": false
      }

      this.restApi.updateSwiftTransfer(payload).subscribe({
        next: (v: updateSwiftTransfers) => {
          this.closeRejectReasonModal();

          if(v.success) {
            this.showAlertBox('Rejected', 'Payment has been rejected.')
          }else{
            this.showAlertBox('Alert', v.message)
          }  
        },
        error: (e) => {}
      })
    }
    else  {
      this.rejectReasonForm.markAllAsTouched();
      this.closeRejectReasonModal();
      return;
    }
  }
}